/** Legal Knowledge Archive permission codes (Legal Repository / Roles & Permissions spec). */
export const LK_PERMISSIONS = {
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  VIEW_EXTRACTED_CASE_OUTCOMES: 'VIEW_EXTRACTED_CASE_OUTCOMES',
  MANAGE_EXTRACTED_CASE_OUTCOMES: 'MANAGE_EXTRACTED_CASE_OUTCOMES',
  VIEW_ARCHIVE_CASES: 'VIEW_ARCHIVE_CASES',
  VIEW_LEGAL_ARCHIVE: 'VIEW_LEGAL_ARCHIVE',
} as const;

export type LkPermissionCode = (typeof LK_PERMISSIONS)[keyof typeof LK_PERMISSIONS];
